import { modalMachine, OpenModalEvent, ShowModalOptions } from '@ui-common/components/Modal'
import { useActor } from '@ui-common/hooks/useActor'
import { createContext, ReactNode, useCallback, useMemo } from 'react'
import { ActorRefFrom } from 'xstate'

interface GlobalServiceContext {
  modalService: ActorRefFrom<typeof modalMachine>
  isModalOpen: boolean
  openModal: (options: ShowModalOptions) => void
}

export const GlobalServicesContext = createContext({} as GlobalServiceContext)

export const GlobalServiceProvider = (props: { children: ReactNode }) => {
  const modalService = useActor(modalMachine)
  const state = modalService.getSnapshot()

  const openModal = useCallback(
    (options: ShowModalOptions) => {
      const event: OpenModalEvent = {
        type: 'OPEN',
        data: options,
      }
      modalService.send(event)
    },
    [modalService],
  )

  const serviceMemo = useMemo(
    () => ({ modalService, isModalOpen: !!state.context.isOpen, openModal }),
    [modalService, state.context.isOpen, openModal],
  )

  return <GlobalServicesContext value={serviceMemo}>{props.children}</GlobalServicesContext>
}
